// extracted by mini-css-extract-plugin
module.exports = {"content":"LinkCard_content___rSf_","imageWrapper":"LinkCard_imageWrapper__cv7bf","text":"LinkCard_text__NDkA1","button":"LinkCard_button__qUiwv"};